export default __webpack_public_path__ + "assets/pinterest.6d6651d6.svg";